import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { Globals } from '../global';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NormalizeMsisdnService {

  // tslint:disable-next-line:max-line-length
  public baseUrl: string = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/msisdn-normalize/v1/normalize';
  // tslint:disable-next-line:max-line-length
  // public baseUrl: string = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/msisdn-normalize/v1/normalize/';

  constructor(
    private http: HttpClient,
    private global: Globals
  ) { }


  getMsisdn(msisdn): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })

    };

    const body = {
      'operatorId': this.global.operatorId,
      'msisdn': msisdn,
    };

    return this.http.post(this.baseUrl, body, httpOptions);
  }

}
